import * as configcat from '@configcat/sdk/browser'
import logger from '@missionlabs/logger'

export const configCatLogger: configcat.IConfigCatLogger = {
    level: configcat.LogLevel.Info,
    log(level, _eventId, message, exception) {
        const text = String(message)

        if (level === configcat.LogLevel.Error) logger.error(text, exception)
        else if (level === configcat.LogLevel.Warn) logger.warn(text, exception)
        else if (level === configcat.LogLevel.Info) logger.info(text, exception)
        else logger.trace(text, exception)
    }
}
